
export default {
    data() {
        return {
            resizeObserver: null,
            fontSize: 0,
        }
    },
    mounted () {
        this.resizeObserver = new ResizeObserver(() => {
            this.updateFontSize();
        });
        this.resizeObserver.observe(this.$refs['render-post']);

        this.$nextTick(() => {
            this.updateFontSize();
        })

    },
    methods: {
       
        updateFontSize() {
            console.log("updateFontSize")
            console.log('updateFontSize',this.$refs['render-post'], this.$refs['render-post'].offsetWidth)
            this.fontSize = this.$refs['render-post'].offsetWidth / 351;
        },
    },

    beforeDestroy () {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
  };